import * as Actions from "../actions";

const INITIAL_STATE = {
  show: false,
  value: "",
  setValue: () => {},
  textArea: false,
  ml: 0,
  showConfirm: false, //confirmation for deleteing images
  onDelete: () => {}, //method for deleteing images
};

export default function editModalReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Actions.SHOW_MODAL:
      return { ...state, ...action.payload };
    case Actions.HIDE_MODAL:
      return { ...state, show: false };
    case Actions.SHOW_MODAL_CONFIRM:
      return { ...state, ...action.payload };
    case Actions.HIDE_MODAL_CONFIRM:
      return { ...state, showConfirm: false };
    default:
      return state;
  }
}
